<template>
  <component
    :is="as"
    class="collection-grid-card"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <div class="image-container">
      <img v-lazy="{ src: card.imageCustom || card.image, error: lightErrorImage }" class="fade" />
    </div>
  </component>
</template>

<script>
import lightErrorImage from '@cardladder/shared/images/empty-card-light.png';

export default {
  props: {
    as: String,
    card: Object,
  },

  data() {
    return {
      lightErrorImage,
    };
  },
};
</script>

<style lang="scss" scoped>
.image-container {
  height: 100%;
  width: 100%;
}

img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
</style>
